import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Share2, Copy } from 'lucide-react';

const API = '/api';

export const ReferralCard = ({ userEmail }) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!userEmail) return;
    axios.get(`${API}/referrals/my-code/${encodeURIComponent(userEmail)}`)
      .then(r => setInfo(r.data))
      .catch(() => setInfo(null));
  }, [userEmail]);

  if (!info?.has_code) return null;
  const link = `${window.location.origin}/book?ref=${info.code}`;
  const text = `Book at HQ Studios with my code ${info.code} and get 20% off your first session: ${link}`;

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: 'HQ Studios', text, url: link }); return; } catch { /* fall back to copy */ }
    }
    await navigator.clipboard.writeText(text);
    toast.success('Referral link copied');
  };

  return (
    <div data-testid="referral-card" className="bg-gradient-to-r from-emerald-900/30 to-teal-900/30 border border-emerald-500/30 rounded-lg p-3">
      <div className="flex items-center justify-between mb-1">
        <span className="text-gray-300 text-sm">Your referral code</span>
        <span data-testid="referral-code" className="text-lg font-bold text-emerald-300 tracking-wider">{info.code}</span>
      </div>
      <p className="text-xs text-gray-300">
        Friends get 20% off their first session. You get a FREE hour every time one books.
      </p>
      <div className="flex items-center justify-between mt-2">
        <span data-testid="referral-count" className="text-xs text-gray-400">
          {info.referrals_count} friend{info.referrals_count === 1 ? '' : 's'} booked · {info.credits_earned} credits earned
        </span>
        <div className="flex gap-2">
          <button data-testid="referral-copy-btn" onClick={async () => { await navigator.clipboard.writeText(link); toast.success('Link copied'); }}
            className="p-1.5 rounded-md bg-emerald-600/30 hover:bg-emerald-600/50 text-emerald-200 transition-colors" aria-label="Copy link">
            <Copy size={14} />
          </button>
          <button data-testid="referral-share-btn" onClick={share}
            className="flex items-center gap-1 px-2 py-1 rounded-md bg-emerald-500 hover:bg-emerald-400 text-black text-xs font-bold transition-colors">
            <Share2 size={12} /> Share
          </button>
        </div>
      </div>
    </div>
  );
};
